import React, { useCallback } from 'react';
import {
  DatePicker,
  Spin,
} from 'antd';
import { Autocomplete, Button, Input, Select,Col } from '@peoplegrove/pg-components';
import { isEmpty } from 'lodash';
import moment from 'moment';
import { useConversationFiltersContext } from '../../context/ConversationFiltersContext';
import useFetchConversations from '../../hooks/useFetchConversations';
import useFetchTagsList from '../../hooks/useFetchTagsList';
import MoreFiltersDropdown from '../../components/MoreFiltersDropdown';
import { disabledDate } from '../../utils/core';
import classes from './Conversations.module.scss';

const { RangePicker } = DatePicker;

const ConversationsFilters = () => {
  const {
    pendingFilters,
    setConversationFilters,
    resetFilters,
    applyFilters,
    isDirty,
    enableClearAll,
  } = useConversationFiltersContext();
  const { isLoading } = useFetchConversations();
  const { data: tagsList, isLoading: isTagsListLoading } = useFetchTagsList();

  const handleFilterChange = useCallback(
    (filter, value) => {
      setConversationFilters(filter, value);
    },
    [setConversationFilters]
  );

  const handleClearAllFilters = useCallback(() => {
    resetFilters();
  }, [resetFilters]);

  const handleKeyDown = e => {
    if (e.key === 'Enter' || e.code === 'Enter') {
      applyFilters();
    }
  };

  const handleSearchChange = (value) => {
    handleFilterChange('searchTerm', value);
  };

  const handleDateRangeChange = useCallback(
    (dateObj, dateStrs) => {
      if (isEmpty(dateObj)) {
        handleFilterChange('dateRange', null);
      } else {
        const [startDate, endDate] = dateStrs;
        handleFilterChange('dateRange', { start: startDate, end: endDate });
      }
    },
    [handleFilterChange]
  );

  if (isTagsListLoading) {
    return <Spin size="large" />;
  }

  return (
    <div className={classes.filtersContainer}>
      <Col span={4}>
      <Input
        placeholder="Search by name"
        value={pendingFilters.searchTerm}
        onChange={handleSearchChange}
        onKeyDown={handleKeyDown}
        size="small"
      />
      </Col>
      <Col span={4} className={classes.dateFilter}>
        <RangePicker
          value={
            pendingFilters.dateRange
              ? [
                  moment(pendingFilters.dateRange.start),
                  moment(pendingFilters.dateRange.end),
                ]
              : []
          }
          onChange={handleDateRangeChange}
          disabledDate={disabledDate}
          format="MM/DD/YYYY"
          allowClear
        />
      </Col>
      <Col span={4} align="center">
        <Autocomplete
          placeholder="Tags"
          multiple={true}
          value={pendingFilters.tags}
          onChange={value => handleFilterChange('tags', value)}
          allowClear
          size="small"
          options={tagsList.map(item => ({
            value: item,
            label: item,
          }))}
          maxPillCount={1}
        >
        </Autocomplete>
      </Col>
      <Col span={3} align="center">
        <Select
          placeholder="CSAT Feedback"
          size="small"
          value={pendingFilters.csatScore}
          onChange={value => handleFilterChange('csatScore', value)}
          options={[1, 2, 3, 4, 5].map(item => ({
            value: item,
            label: item,
          }))}
        >
        </Select>
      </Col>
      <Col span={2} align="center">
        <MoreFiltersDropdown />
      </Col>
      <Col span={6} align="center" className={classes.filterButtonsContainer}>
        <Button
          type="secondary"
          disabled={isLoading || !isDirty}
          onClick={applyFilters}
          size="small"
        >
          Apply Filters
        </Button>
        
        <Button
          type="secondary"
          color="red"
          size="small"
          disabled={isLoading || !enableClearAll}
          onClick={handleClearAllFilters}
        >
          Clear All
        </Button>
      </Col>
    </div>
  );
};

export default ConversationsFilters;
